module.exports = __webpack_public_path__ + "img/refresh.691c19a3.png";